/**
 * Smooth scrolling
 */

export default function () {
    const btnscroll = document.querySelectorAll('.btn-scrolling');
    if(btnscroll) {
        btnscroll.forEach(function(button) {
            button.addEventListener('click', function(e) {
              e.preventDefault();
          
              if (window.location.hostname === this.hostname) {
                var target = document.querySelector(this.hash);
                target = target ? target : document.querySelector('[name=' + this.hash.slice(1) + ']');
          
                if (target) {
                  var extraOffset = parseInt(this.getAttribute('data-extra-offset')) || 0;
                  var targetOffsetTop = target.getBoundingClientRect().top + window.scrollY;
                  var scrollTo = targetOffsetTop - 250 - extraOffset;
          
                  window.scrollTo({
                    top: scrollTo,
                    behavior: 'smooth'
                  });
                }
              }
            });
          });
    }

    window.addEventListener("load", function () {
        if (window.location.hash) {
            var element = document.querySelector(window.location.hash);
    
            if (element) {
                element.scrollIntoView({behavior:"smooth",offset:{top:-250}});
            }
        }
    });
    
}

// $('.btn-scrolling').click(function doSmoothScrolling(e) {

//     e.preventDefault();

//     if (window.location.hostname === this.hostname) {

//         let target = $(this.hash);
//         target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

//         if (target.length) {

//             $('html, body').animate({
//                 // scrollTop: target.offset().top - ($(this).data('extra-offset') || 0),
//                 scrollTop: target.offset().top - 250,
//             }, 600);

//         }

//     }

// });



// /* 
// * Smooth Scroll on Pageload
// * Smooth scrolling on page load if URL have a hash
// */

// window.addEventListener("load", function () {
//     if (window.location.hash) {
//         var hash = window.location.hash;
        
//         if (jQuery(hash).length) {
//             jQuery('html, body').animate({
//                 scrollTop: jQuery(hash).offset().top - 250
//             }, 900, 'swing');
//         }
//     }
// });